// Generated by ReScript, PLEASE EDIT WITH CARE


function toFloat(value) {
  if (value === "none") {
    return 0;
  } else if (value === "xhuge" || value === "xxhuge") {
    return 64;
  } else if (value === "xxlarge") {
    return 32;
  } else if (value === "xlarge") {
    return 24;
  } else if (value === "large") {
    return 20;
  } else if (value === "xxsmall") {
    return 2;
  } else if (value === "xsmall") {
    return 4;
  } else if (value === "xmedium") {
    return 14;
  } else if (value === "medium") {
    return 16;
  } else if (value === "small") {
    return 8;
  } else if (value === "xnormal") {
    return 10;
  } else if (value === "normal") {
    return 12;
  } else {
    return 48;
  }
}

function toPx(value) {
  if (value === "none") {
    return "unset";
  } else if (value === "xhuge" || value === "xxhuge") {
    return "64px";
  } else if (value === "xxlarge") {
    return "32px";
  } else if (value === "xlarge") {
    return "24px";
  } else if (value === "large") {
    return "20px";
  } else if (value === "xxsmall") {
    return "2px";
  } else if (value === "xsmall") {
    return "4px";
  } else if (value === "xmedium") {
    return "14px";
  } else if (value === "medium") {
    return "16px";
  } else if (value === "small") {
    return "8px";
  } else if (value === "xnormal") {
    return "10px";
  } else if (value === "normal") {
    return "12px";
  } else {
    return "48px";
  }
}

let xxsmall = 2;

let xsmall = 4;

let small = 8;

let xnormal = 10;

let normal = 12;

let xmedium = 14;

let medium = 16;

let large = 20;

let xlarge = 24;

let xxlarge = 32;

let huge = 48;

let xhuge = 64;

let xxhuge = 96;

export {
  xxsmall,
  xsmall,
  small,
  xnormal,
  normal,
  xmedium,
  medium,
  large,
  xlarge,
  xxlarge,
  huge,
  xhuge,
  xxhuge,
  toFloat,
  toPx,
}
/* No side effect */
